import PageviewIcon from '@mui/icons-material/Pageview';

export const FilterPreviewHeader = ({ 
    title = "Filter Preview", 
    subtitle = "Review and save your filter configuration" 
}) => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            padding: "0.75rem 1rem",
            backgroundColor: "#ffffff",
            borderRadius: "6px",
            marginBottom: "0.75rem",
            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            flexShrink: 0
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                backgroundColor: "#e3f2fd",
                borderRadius: "8px"
            }}>
                <PageviewIcon style={{ fontSize: "18px", color: "#007bff" }} />
            </div>
            
            <div style={{ flex: 1 }}>
                <h2 style={{
                    margin: 0,
                    color: "#007bff",
                    fontSize: "16px",
                    fontWeight: "600"
                }}>{title}</h2>
                <p style={{
                    margin: "0.125rem 0 0 0",
                    color: "#6c757d",
                    fontSize: "12px"
                }}>{subtitle}</p>
            </div>
        </div>
    );
};
